import { Link, LinkProps } from 'react-router-dom';

const NewTabLink = (props: LinkProps) => (
  <Link {...props} target='_blank' rel='noopener noreferrer' />
);

export default NewTabLink;
